<template>
  <svg
    width="122"
    height="165"
    viewBox="0 0 122 165"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="61"
      cy="61"
      r="61"
      fill="#F7F7F7"
    />
    <g filter="url(#filter0_d_2720_20884)">
      <rect
        x="22"
        y="29"
        width="77.8605"
        height="108"
        rx="4"
        fill="white"
      />
    </g>
    <rect
      opacity="0.7"
      x="32.0449"
      y="41.584"
      width="18.8372"
      height="6.27907"
      rx="2"
      stroke="#BFBFBF"
      stroke-linecap="round"
      stroke-dasharray="3 2"
    />
    <rect
      opacity="0.7"
      x="32.0449"
      y="59.3965"
      width="57.7674"
      height="6.27907"
      rx="2"
      stroke="#BFBFBF"
      stroke-linecap="round"
      stroke-dasharray="3 2"
    />
    <rect
      opacity="0.7"
      x="32.0449"
      y="71.2109"
      width="57.7674"
      height="6.27907"
      rx="2"
      stroke="#BFBFBF"
      stroke-linecap="round"
      stroke-dasharray="3 2"
    />
    <rect
      opacity="0.7"
      x="32.0449"
      y="83.0254"
      width="57.7674"
      height="6.27907"
      rx="2"
      stroke="#BFBFBF"
      stroke-linecap="round"
      stroke-dasharray="3 2"
    />
    <rect
      opacity="0.7"
      x="32"
      y="97"
      width="58"
      height="28"
      rx="2"
      stroke="#BFBFBF"
      stroke-linecap="round"
      stroke-dasharray="3 2"
    />
    <defs>
      <filter
        id="filter0_d_2720_20884"
        x="2"
        y="17"
        width="117.86"
        height="148"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="8" />
        <feGaussianBlur stdDeviation="10" />
        <feComposite
          in2="hardAlpha"
          operator="out"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2720_20884"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2720_20884"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
</template>
<script>
export default {
  name: "EmptyStateImg"
};
</script>
